import { adios } from '@adserve/adserve-react-components';
import axios from 'axios';
import qs from 'qs';
import { crmApi, starter2Api } from '../../../constants/Endpoint';

export const AccountsLookup = async (searchTerm, params, type) => {
    const results = await adios(() =>
        axios.get(`${crmApi}/Accounts/Lookup`, {
            params: {
                ...params,
                searchTerm: encodeURIComponent(searchTerm),
                accountType: type
            }
        })
    );

    return results?.data;
};

export const DealsLookup = async (searchTerm, params, filter) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/Deals/Lookup`, {
            params: {
                ...params,
                searchTerm: encodeURIComponent(searchTerm),
                advertiserId: filter.advertiserId,
                agencyId: filter.agencyId,
                revenueTypeId: filter.revenueTypeId,
                campaignId: filter.campaignId,
                startDate: filter.startDate,
                endDate: filter.endDate,
                dealVersionId: filter.dealVersionId
            },
            paramsSerializer: (params) => {
                return qs.stringify(params);
            }
        })
    );

    return results.data;
};

export const CategoriesLookup = async (searchTerm, params) => {
    const response = await adios(() =>
        axios.get(`${starter2Api}/productcategories/search`, {
            params: {
                ...params,
                name: encodeURIComponent(searchTerm)
            }
        })
    );

    return response?.data;
};
export const DemographicsLookup = async (searchTerm, params) => {
    const response = await adios(() =>
        axios.get(`${starter2Api}/demographics/search`, {
            params: {
                ...params,
                name: searchTerm
            }
        })
    );

    return response?.data;
};
export const ContactsLookup = async (searchTerm, params) => {
    const results = await adios(() =>
        axios.get(`${crmApi}/Contacts/Lookup`, {
            params: {
                ...params,
                searchTerm: encodeURIComponent(searchTerm)
            }
        })
    );

    return results.data;
};

export const UsersLookup = async (searchTerm, params) => {
    const response = await adios(() =>
        axios.get(`${crmApi}/users/search`, {
            params: {
                ...params,
                searchTerm: encodeURIComponent(searchTerm)
            }
        })
    );

    return response?.data;
};

export const CampaignsLookup = async (searchTerm, params, externalSourceIds) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/Campaigns/Lookup`, {
            params: {
                pageNumber: 1,
                pageSize: -1,
                accountId: window.emptyGuid,
                ...params,
                searchTerm: encodeURIComponent(searchTerm),
                businessType: undefined,
                externalSourceIds: externalSourceIds
            },
            paramsSerializer: (params) => {
                return qs.stringify(params);
            }
        })
    );

    return results.data;
}

export const InternalUsersLookup = async (searchTerm, params) => {
    const response = await adios(() =>
        axios.get(`${starter2Api}/Users/Search`, {
            params: {
                ...params,
                searchTerm: searchTerm
            }
        })
    );

    return response?.data;
};

export const GetSalesTeams = async (apiParams) => {
    try {
        const data = await adios(() =>
            axios.get(starter2Api + '/salesteams', { params: apiParams })
        );
        return {
            data: data?.data
        };
    } catch (err) {
        console.error(err);
    }
};